import {
    memo,
    type PropsWithChildren
} from "react";
import { isFormChanged } from "util/forms";
import { AdvancedTabLabel } from "ui/molecules/Label";
import type { TabLabelProps } from "./types";

const TabLabel = ({
    value,
    tab,
    children,
    message,
    tabManager,
    selectState
}: PropsWithChildren<TabLabelProps>) => (
    <AdvancedTabLabel
        isError={(
            !Object.is(tabManager.getTab(value), tab) &&
            !selectState(tab).isValid &&
            isFormChanged(selectState(tab))
        )}
        message={message}
    >
        {children ?? tab}
    </AdvancedTabLabel>
);

export default memo(TabLabel);
